@let hasShiftReadPermission = can(RoleAction.Read, RolePermissionSubject.Shift);

<div
  nz-tooltip
  [nzTooltipTitle]="
    !hasChangePermissions ? ('general.forbidden_action' | translate) : ''
  "
>
  @if (shiftExternalWorkflows.length) {
    <button
      data-test-id="wilson-csv-box-import:button"
      nz-button
      nz-dropdown
      [disabled]="isLoading || !hasChangePermissions"
      [nzLoading]="isLoading"
      nzType="default"
      nzTrigger="click"
      [nzDropdownMenu]="action"
    >
      <span>{{ btnText }}</span>
      <i class="ms-2" nz-icon nzType="down"></i>
    </button>

    <nz-dropdown-menu #action="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item class="fw-normal">
          <csvbox-button
            class="csvbox-btn w-100"
            [language]="language"
            [licenseKey]="licenseKey"
            [imported]="imported.bind(this)"
            [user]="csvBoxUser"
            [lazy]="true"
            [disabled]="isLoading || !hasChangePermissions"
            [importerReady]="onImporterReadyHandler.bind(this)"
            [loadStarted]="onLoadHandler.bind(this)"
          >
            <div class="d-flex align-items-center w-100">
              <span>{{ 'csvbox.shift.import' | translate }}</span>
            </div>
          </csvbox-button>
        </li>
        @if (shiftExternalWorkflows && shiftExternalWorkflows.length) {
          @for (
            shiftExternalWorkflow of shiftExternalWorkflows;
            track shiftExternalWorkflow.id
          ) {
            <li
              class="fw-normal"
              nz-menu-item
              data-test-id="wilson-shift-actions-menu:external-action"
              (click)="
                hasShiftReadPermission &&
                  performExternalAction.emit(shiftExternalWorkflow.url)
              "
            >
              {{ shiftExternalWorkflow.translatedName }}
            </li>
          }
        }
      </ul>
    </nz-dropdown-menu>
  } @else {
    <csvbox-button
      class="csvbox-btn w-100"
      [language]="language"
      [licenseKey]="licenseKey"
      [imported]="imported.bind(this)"
      [user]="csvBoxUser"
      [lazy]="true"
      [disabled]="isLoading || !hasChangePermissions"
      [importerReady]="onImporterReadyHandler.bind(this)"
      [loadStarted]="onLoadHandler.bind(this)"
    >
      <button
        nz-button
        nzType="default"
        [disabled]="isLoading || !hasChangePermissions"
        [nzLoading]="isLoading"
        class="p-1 w-100 fw-normal px-3"
        data-test-id="wilson-csv-box-import:button"
      >
        {{ btnText }}
      </button>
    </csvbox-button>
  }
</div>
